<template>
  <div class="dimed wrap">
    <div class="layer layer--nobutton" @mouseup="closeAdultCertFinish">
      <div class="layer__header">
        <div class="lyr-title">{{ $t('User.AdultCertification.msg8') }}</div>
      </div>
      <div class="layer__body">
        <div class="ft--xlg ft--bold">{{ $t('User.AdultCertification.msg9') }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'adultCertFinish',
  data() {
    return {
      darkModeYn: this.$store.getters.getDarkModeYn,
      timer: null,
    };
  },
  unmounted() {
    clearTimeout(this.timer);
  },
  mounted() {
    this.timer = setTimeout(() => {
      this.$emit('closeAdultCertFinish');
    }, 5000);
  },
  props: {},
  methods: {
    closeAdultCertFinish() {
      clearTimeout(this.timer);
      this.$emit('closeAdultCertFinish');
    },
  },
  watch: {
    darkMode() {
      this.darkModeYn = this.darkModeYn ? false : true;

      this.$changeDarkMode(this.darkModeYn);
    },
  },
};
</script>

<style src="@/assets/css/user/common.css" scoped></style>
<style src="@/assets/css/user/dark/common-dark.css" scoped></style>
<style scoped></style>
